export const messages = {
  en: {
    deleteOrg: {
      title: 'Delete Organization',
      confirm: 'Are you sure to delete this organization? This action cannot be undone.',
      deleteSuccess: 'Organization deleted successfully',
      deleteFailed: 'Failed to delete organization',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      hasChildren: 'Cannot delete organization with child organizations',
      hasStaff: 'Cannot delete organization with staff members'
    }
  },
  zh: {
    deleteOrg: {
      title: '删除组织',
      confirm: '确定要删除这个组织吗？此操作无法撤销。',
      deleteSuccess: '组织删除成功',
      deleteFailed: '组织删除失败',
      cancel: '取消',
      confirmDelete: '确认删除',
      hasChildren: '无法删除包含子组织的组织',
      hasStaff: '无法删除包含员工的组织'
    }
  }
} 